module.exports = __webpack_public_path__ + "static/media/pharmacy.5b2478af.png";